import { useMemo, useState } from 'react'
import { SETTINGS_NAV_GROUPS } from '@/data/settingsNavData'

export function useSettingsSectionFilter() {
  const [searchValue, setSearchValue] = useState('')

  const filteredGroups = useMemo(() => {
    const q = searchValue.trim().toLowerCase()
    if (!q) return SETTINGS_NAV_GROUPS
    return SETTINGS_NAV_GROUPS.map((group) => {
      const labelHit = group.label.toLowerCase().includes(q)
      const items = labelHit ? group.items : group.items.filter((item) => item.label.toLowerCase().includes(q))
      return { ...group, items }
    }).filter((g) => g.items.length > 0)
  }, [searchValue])

  return { searchValue, setSearchValue, filteredGroups }
}
